import gql from 'graphql-tag';

export default gql`
  query childFoldersFileQuery($parentId: ID!, $search: String) {
    childFoldersFileQuery(parentId: $parentId, search: $search) {
      id
      name
      isFolder
      parentId
    }
  }
`;
